/**
 * https://github.com/mui/mui-x/issues/6716
 * MUI date pickers can emit an `Invalid Date` object while the user is typing.
 * Treat that the same as an empty value so form handlers never call date methods on an invalid date.
 */
export const toUtcMidnightIsoString = (date: Date | null | undefined): string => {
  if (!date || Number.isNaN(date.getTime())) {
    return '';
  }

  const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  return utcDate.toISOString();
};

export const convertIsoDateToLocalDate = (isoDate: string | null | undefined): Date | null => {
  if (!isoDate) {
    return null;
  }

  const dateObj = new Date(isoDate);
  if (Number.isNaN(dateObj.getTime())) {
    return null;
  }

  return new Date(dateObj.getUTCFullYear(), dateObj.getUTCMonth(), dateObj.getUTCDate());
};
